// src/router/index.js
import Vue from 'vue'
import Router from 'vue-router'

// 导入页面组件（可先创建简单页面）
import index from '../page/indexPage.vue'
import login from '../page/loginPage.vue'
import Changepassword from '../page/Changepassword'
import ManagementList from '../page/managementlist.vue'
import EquipmentUnderApplication from '../page/EquipmentUnderApplication.vue'
import DisabledDeviceList from '../page/DisabledDeviceList.vue'
import ApikeyPage from '../page/ApikeyPage.vue'
// 注册Router插件
Vue.use(Router)

// 定义路由规则
const routes = [
  {
    path: '/',
    name: 'index',
    component: index ,// 首页组件
    children:[
		{
			path:'changepassword',
			component:Changepassword
		},
		{
			path:'managementlist',
			component:ManagementList
		},
		{
			path:'equipment-application',
			component:EquipmentUnderApplication
		},
		{
			path:'disabled-devices',
			component:DisabledDeviceList
		},
		{
			path:'apikey-management',
			component:ApikeyPage
		}
	]
  },
  {
    path: '/login',
    name: 'login',
    component: login // 首页组件
  }
]

// 创建路由实例
const router = new Router({
  mode: 'hash', // Vue 2推荐使用hash模式（history模式需后端配置）
  routes // 传入路由规则
})

export default router